import * as React from "react";
import { forwardRef } from "react";
const SvgChevronDown24 = (props, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M3.51465 8.4652L11.9996 16.9502L20.4846 8.4652L19.0706 7.0502L11.9996 14.1222L4.92865 7.0502L3.51465 8.4652Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgChevronDown24);
export default ForwardRef;
